// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"zba-z","narrowOptionButtons":"Aba-z","noOptions":"Bba-z"};